import { render, staticRenderFns } from "./AddressViewer.vue?vue&type=template&id=58259de2"
import script from "./AddressViewer.vue?vue&type=script&lang=ts"
export * from "./AddressViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports